import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type MarketsAction = ActionType<typeof actions>;

export enum MarketsActionTypes {
  FETCH_REQUEST = "@Markets/FETCH_REQUEST",
  FETCH_SUCCESS = "@Markets/FETCH_SUCCESS",
  FETCH_ERROR = "@Markets/FETCH_ERROR",
}

export interface MarketsState {
  readonly markets: string[];
  readonly isLoading: boolean;
}

export interface MarketPayload {
  market?: string;
}
